import React from 'react'
import ReactDOM from 'react-dom/client'
import { FormatRegistry } from '@sinclair/typebox'
import App from '@/App'
import '@/index.css'

// TypeBox runtime format checkers — registered once at boot. Without this,
// schemas using `Type.String({ format: 'email' })` (login form, etc.) fail
// the typebox resolver with "Unknown format 'email'" because the formats
// are not auto-registered by the library. Mirrors the registration in
// `apps/api/src/server.ts` so admin and api use identical validators.
if (!FormatRegistry.Has('email')) {
  FormatRegistry.Set('email', (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/u.test(value))
}
if (!FormatRegistry.Has('uuid')) {
  FormatRegistry.Set('uuid', (value: string) =>
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/u.test(value),
  )
}
if (!FormatRegistry.Has('date-time')) {
  FormatRegistry.Set('date-time', (value: string) => !Number.isNaN(Date.parse(value)))
}

const rootEl = document.getElementById('root')
if (!rootEl) {
  throw new Error('Root element #root not found in index.html')
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
